import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSeconds'
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);

    // Return seconds only
    if (minutes <= 0) {
      return (value - minutes * 60).toString().padStart(2, '0') + 's';
    }

    // Return minutes only
    if ((value - minutes * 60) <= 0) {
      return minutes.toString() + 'm';
    }

    // Return minutes and seconds
    return minutes.toString() + 'm ' +
      (value - minutes * 60).toString().padStart(2, '0') + 's';
  }
}
